import React, { useContext } from "react";
import style from "./index.module.scss";
import useRequest from "Utils/useRequest";
import { getStuVoteList } from "API/vote";
import { CourseContext } from "../Store";
import ListItem from "./components/ListItem";
import { Spin } from "antd";
import CustomEmpty from "components/CustomEmpty";

export default function Vote() {
    const { course, basename } = useContext(CourseContext);
    const [data, { loading }] = useRequest(() =>
        getStuVoteList(course.weekTimeId)
    );

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    投票活动（{data?.length || 0}）
                </div>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem key={item.id} data={item} basename={basename} />
                ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
